<template>
  <div class="con">
    
        
  </div>
</template>

<script>
export default {
    name:'about',
  data() {
    return {
      activeIndex: "about",
      activeIndex2: "1",
      keepaliveArr: [],
      refreshKeepalive: true,
      
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key,keyPath)
    },
  },
};
</script>

<style>

*{
  margin: 0;
  padding: 0;
}
.con {
  width: 100vw;
}
.el-menu-demo {
  display: flex;
  justify-content: center;
  background: #fff;
  height: 60px;
}

@media screen and (min-width: 800px) {

 
}
</style>